import React from 'react';


export type LinkObject = {
    url: string
    text: string
    time: any
}
type ContentTitleProps = {
    title: string
    festival?: null | LinkObject
}
export const ContentTitle = (props: ContentTitleProps) => {
    const { title, festival } = props;

    return (
        <>
            <div className='event-title'>{title}</div>
            { festival && festival.url ?
                <div className='event-festival-link'>
                    <a href={`${festival.url}/`}>
                        { festival.text ? festival.text : festival.url}
                    </a>
                </div> :
              null
            }
    </>
    )
}
